// PricingForm.js

import React from 'react';
import { Form, Input, Button, Select, InputNumber } from 'antd';

const { Option } = Select;

const PricingForm = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // Add logic to send the form data to the server or perform other actions
    console.log('Form submitted:', values);
    // Reset the form after submission
    form.resetFields();
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 8 }}
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <Form.Item label="Company Cost - Authentication" name="companyCostAuthentication">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Company Cost - Marketing" name="companyCostMarketing">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Company Cost - Service" name="companyCostService">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Company Cost - Utility" name="companyCostUtility">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Company Cost - Unknown Type" name="companyCostUnknownType">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Company Cost - Session" name="companyCostSession">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Customer Cost - Authentication" name="customerCostAuthentication">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Customer Cost - Marketing" name="customerCostMarketing">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Customer Cost - Service" name="customerCostService">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Customer Cost - Utility" name="customerCostUtility">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Customer Cost - Unknown Type" name="customerCostUnknownType">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Customer Cost - Session" name="customerCostSession">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Add Pricing
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PricingForm;

